import axios from 'axios';
import {
  createSignedGetRequest,
  createSignedPostRequest,
} from 'utils/createSignedRequestsHelpers';

/**
 * The API path of a bank DWG file's 3D conversion: a private item (it has an
 * `s3Key`) by its project and id, a public FilePermission by its id.
 * @param {Object} file the raw bank item the viewer opened
 * @returns {string}
 */
export const dwgConversionApiPath = (file) =>
  file.s3Key
    ? `project-bank/private/project/${file.projectId}/file/${file.id}/dwg-conversion`
    : `files/project-bank/${file.id}/dwg-conversion`;

/**
 * Where a DWG's conversion stands.
 * @returns {Promise<{status: 'none'|'running'|'done'|'failed', glbUrl?: string,
 *   approximatedFaces?: number, error?: string}>}
 */
export const getDwgConversion = async (file) => {
  const signedRequest = await createSignedGetRequest({
    apiPath: dwgConversionApiPath(file),
  });
  const response = await axios(signedRequest);
  return response.data;
};

/**
 * Starts converting a DWG unless it is converted or converting already;
 * answers where it stands, like getDwgConversion.
 */
export const postStartDwgConversion = async (file) => {
  const signedRequest = await createSignedPostRequest({
    apiPath: dwgConversionApiPath(file),
    body: {},
  });
  const response = await axios(signedRequest);
  return response.data;
};
